import { Box, BoxProps, Flex } from '@chakra-ui/react';

import { Image } from '$components/chakra/image';

interface SafariMockProps extends Omit<BoxProps, 'children'> {
  src: string;
  alt: string;
  url?: string;
  compact?: boolean;
}

export function SafariMock({
  src,
  alt,
  url,
  compact = false,
  ...props
}: SafariMockProps) {
  const chromeHeight = compact ? '22px' : '34px';
  const dotSize = compact ? '6px' : '10px';
  const dotGap = compact ? '4px' : '6px';

  return (
    <Box
      display="flex"
      flexDirection="column"
      w="full"
      h="full"
      borderRadius={compact ? '8px' : '12px'}
      borderWidth="1px"
      borderColor="line.strong"
      overflow="hidden"
      bg="bg.surface"
      boxShadow={compact ? 'none' : '0 18px 50px -20px rgba(20, 17, 14, 0.20)'}
      {...props}
    >
      <Flex
        h={chromeHeight}
        flexShrink={0}
        align="center"
        gap={compact ? '8px' : '12px'}
        px={compact ? '8px' : '14px'}
        bg="bg.elevated"
        borderBottomWidth="1px"
        borderColor="line.subtle"
      >
        <Flex gap={dotGap}>
          <Box w={dotSize} h={dotSize} borderRadius="full" bg="#FF5F57" />
          <Box w={dotSize} h={dotSize} borderRadius="full" bg="#FEBC2E" />
          <Box w={dotSize} h={dotSize} borderRadius="full" bg="#28C840" />
        </Flex>

        {!compact && (
          <Box
            flex="1"
            maxW="60%"
            mx="auto"
            px="12px"
            py="3px"
            borderRadius="999px"
            bg="bg.surface"
            fontFamily="mono"
            fontSize="11px"
            color="text.faint"
            textAlign="center"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {url ?? '—'}
          </Box>
        )}
      </Flex>

      <Box flex="1" pos="relative" minH="0" bg="bg.surface">
        <Image src={src} alt={alt} objectFit="contain" w="100%" h="100%" />
      </Box>
    </Box>
  );
}
